module.exports = __webpack_public_path__ + "static/606196416.9e4ffffd.jpg";